
















import DropdownClassification from "@/components/transactionCreate/componentClassification/DropdownClassification.vue";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({ components: { DropdownClassification } })
export default class SectionClassification extends Vue {
  @Prop({}) transactionCreate!: any;
}
